<ion-title class="top-bar-title ion-text-center" (click)="goToFleetView()">
  {{ (currentDevice$ | async)?.settings?.deviceName }}
</ion-title>
